import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const VBP00Table: GenericTableSchemaInterface = {
  id: "vbp-00",
  name: "VBP 00",
  description: "This table contains data regarding value based pricing.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Location Name",
      variable: VarKey.LocationName,
    },
    c02: {
      name: "Start",
    },
    c03: {
      name: "Experiment Type",
    },
    c04: {
      name: "End",
    },
    c05: {
      name: "Recommended Tier",
    }
  },
};
